import React from "react";
import { Col } from "react-bootstrap";
import circleredclose from "assets/images/close-circlered.svg";
import editprofile from "assets/images/edit-profile.svg";
import deafultuserImg from "assets/images/avatar.svg";
import { formatPhoneNumber } from "utils";
import BioSection from "Dashboard/Dashboardpages/Bio"; // Assuming absolute import or alias works, otherwise adjusted below

const PersonalDetails = ({ user, handleShow, handleFileUpload, setIsDelete }) => {
    return (
        <div className="profile-cards">
            <div className="d-flex align-items-center box-profile">
                <div className="avatar-upload">
                    <div className="avatar-edit">
                        <input
                            type="file"
                            id="imageUpload"
                            accept=".png, .jpg, .jpeg"
                            name="avatar"
                            onChange={handleFileUpload}
                        />
                        <label htmlFor="imageUpload" />
                    </div>
                    <div className="avatar-preview">
                        <div id="imagePreview">
                            <img
                                alt="User Avatar"
                                className="rounded-circle border border-secondary"
                                src={`${user?.baseS3Url}${user?.avatar || ""}`}
                                onError={(e) => {
                                    e.currentTarget.onerror = null;
                                    e.currentTarget.src = deafultuserImg;
                                }}
                            />
                        </div>
                    </div>
                </div>
                <p className="mb-0">{user?.fullName}</p>
            </div>
            <div className="profie-heding">
                <div className="d-flex justify-content-between align-items-center">
                    <h4>Personal Details</h4>
                    <div onClick={() => handleShow("personal")}>
                        <img src={editprofile} className="cursor-pointer" alt="Edit" />
                    </div>
                </div>
            </div>
            <div className="details-profiles">
                <div className="mb-4">
                    <p className="light-text-profile">Email</p>
                    <p className="dark-profile-text">{user?.email}</p>
                </div>
                <div className="mb-4">
                    <p className="light-text-profile">Mobile</p>
                    <p className="dark-profile-text">
                        {formatPhoneNumber(user?.formattedNumber)}
                    </p>
                </div>
                <Col lg={6}>
                    <div className="mb-4">
                        <p className="light-text-profile">Business Name</p>
                        <p className="dark-profile-text">{user?.businessName}</p>
                    </div>
                </Col>
                <div className="mb-4">
                    <p className="light-text-profile">Address</p>
                    <p className="dark-profile-text">{user?.address}</p>
                </div>
                {user?.specialisedId?.length > 0 && (
                    <div>
                        <p className="light-text-profile">Specialized</p>
                        <div className="d-flex gap-3 flex-wrap">
                            {user?.specialisedId.map((item) => {
                                return (
                                    <span className="blue-bedge" key={item?._id}>
                                        {item?.title}
                                    </span>
                                );
                            })}
                        </div>
                    </div>
                )}
                <div className="mt-4">
                    <BioSection bio={user?.bio} />
                </div>
            </div>
            <button
                onClick={() => {
                    setIsDelete(true);
                }}
                className="profile-cards bg-transparent w-100 delete-btn d-flex justify-content-center align-items-center text-center mt-3"
            >
                <div>
                    <img src={circleredclose} className="me-2" alt="" />
                    Delete Account
                </div>
            </button>
        </div>
    );
};

export default PersonalDetails;
